/*
 * Instantanés locaux des dernières réponses API réussies, pour que le portail
 * reste consultable quand le réseau tombe (PWA installée).
 *
 * Délibérément en localStorage et non dans le cache du service worker : ces
 * données appartiennent à l'utilisateur connecté, et une déconnexion doit
 * pouvoir les effacer — ce qu'on ne sait pas faire proprement sur un cache HTTP
 * indexé par URL et partagé par tous les profils du navigateur. Rien de plus
 * sensible n'y est stocké que ce que l'utilisateur a déjà sous les yeux : son
 * profil et la liste d'outils qui lui est destinée.
 */

const PREFIXE = 'portail:offline:';

// Un instantané ne survit pas indéfiniment. Passé ce délai, mieux vaut un
// portail vide qu'une liste d'outils vieille d'un mois : les accès ont pu être
// révoqués entre-temps, et rien ne le dirait à l'utilisateur.
const DUREE_MAX_MS = 7 * 24 * 60 * 60 * 1000;

export const readSnapshot = (cle) => {
  try {
    const brut = localStorage.getItem(PREFIXE + cle);
    if (!brut) return null;
    const { savedAt, data } = JSON.parse(brut);
    if (data === undefined) return null;
    if (typeof savedAt !== 'number' || Date.now() - savedAt > DUREE_MAX_MS) {
      localStorage.removeItem(PREFIXE + cle);
      return null;
    }
    return { savedAt, data };
  } catch {
    // Navigation privée, quota, JSON corrompu : on repart sans instantané.
    return null;
  }
};

export const writeSnapshot = (cle, data) => {
  try {
    localStorage.setItem(PREFIXE + cle, JSON.stringify({ savedAt: Date.now(), data }));
  } catch {
    // Stockage plein ou refusé : perdre l'instantané n'empêche rien.
  }
};

export const clearSnapshots = () => {
  try {
    Object.keys(localStorage)
      .filter(k => k.startsWith(PREFIXE))
      .forEach(k => localStorage.removeItem(k));
  } catch {
    // idem
  }
};

// Une erreur axios sans objet `response` n'a jamais atteint le serveur (hors
// ligne, DNS, timeout) : la session n'a pas été rejetée, elle est juste
// invérifiable pour l'instant. C'est toute la différence avec un vrai 401.
export const estErreurReseau = (error) => !error?.response;
